export interface PromoCodeStatusUpdateRequestModel {
  active: boolean;
}
